import type { WebSite, SearchAction } from 'schema-dts';
import { siteName, siteUrl, sameAs } from '$lib/config';

type MySearchAction = SearchAction & {
  'query-input': string;
};

type MyWebSite = WebSite & {
  potentialAction: MySearchAction;
};

export default function getWebSite(): MyWebSite {
  return {
    '@type': 'WebSite',
    name: siteName,
    url: `${siteUrl}/`,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/recherche?query={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
    sameAs,
  };
}
